<template>
    <div v-if="isMounted" v-loading="$parentInfo.schoolScore.loading">
        <!--        <el-tabs v-model="$parentInfo.schoolScore.activeTab">-->
        <!--            <el-tab-pane label="学校成绩单" name="1">-->
        <el-row :gutter="20">
            <el-col :span="24" v-if="$parentInfo.canUse">
                <el-button @click="addScore()" size="small" :disabled="$parentInfo.schoolScore.disableYN">
                    添加学校成绩
                </el-button>
            </el-col>
        </el-row>
        <hr style="margin-top: 10px;margin-bottom: 10px; filter: alpha(opacity=100,finishopacity=0,style=3)"
            width="100%" color=#B3C0D1 size=1>
        <vue-scroll :ops="$ops" :style="{'height': $parentInfo.clientHeight-600+$parentInfo.heightChange+'px'}">
            <table class="table">
                <thead>
                <tr>
                    <th>考试名称</th>
                    <th>考试日期</th>
                    <th>年级</th>
                    <th>班级</th>
                    <th>三总成绩</th>
                    <th>全科总成绩</th>
                    <th>班级三总平均分/排名</th>
                    <th>年级三总平均分/排名</th>
                    <th>区三总平均分/排名</th>
                    <th>班级全科总平均分/排名</th>
                    <th>年级全科总平均分/排名</th>
                    <th>区全科总平均分/排名</th>
                    <th v-if="$parentInfo.canUse">操作</th>
                </tr>
                </thead>
                <tbody>
                <template v-for="item in orderSchoolScores">
                    <tr @click="hasExamDetail(item)">
                        <td v-if="item.schoolExam">{{item.schoolExam.name}}</td>
                        <td v-else>学校考试未填写</td>
                        <td>{{item.schoolExam.date}}</td>
                        <td v-if="item.schoolExam.grade">{{item.schoolExam.grade.name}}</td>
                        <td v-else>年级未填写</td>
                        <td>{{item.schoolClass}}</td>
                        <td>{{item.mainScore}}</td>
                        <td>{{item.sumScore}}</td>
                        <td v-if="item.school_exam_school_class">
                            {{item.school_exam_school_class.mainClassAvgScore}}&nbsp;/&nbsp;{{item.mainClassRank}}
                        </td>
                        <td v-else>&nbsp;/&nbsp;{{item.mainClassRank}}</td>
                        <td>{{item.schoolExam.mainGradeAvgScore}}&nbsp;/&nbsp;{{item.mainGradeRank}}</td>
                        <td>{{item.schoolExam.mainAreaAvgScore}}&nbsp;/&nbsp;{{item.mainAreaRank}}</td>
                        <td v-if="item.school_exam_school_class">
                            {{item.school_exam_school_class.sumClassAvgScore}}&nbsp;/&nbsp;{{item.sumClassRank}}
                        </td>
                        <td v-else>&nbsp;/&nbsp;{{item.sumClassRank}}</td>
                        <td>{{item.schoolExam.sumGradeAvgScore}}&nbsp;/&nbsp;{{item.sumGradeRank}}</td>
                        <td>{{item.schoolExam.sumAreaAvgScore}}&nbsp;/&nbsp;{{item.sumAreaRank}}</td>
                        <td @click="hasExamDetail(item)" v-if="$parentInfo.canUse">
                            <el-button type="primary" @click="handleUpdateMainSchoolScore(item)"
                                       style="margin-right: 10px"
                                       :loading="$parentInfo.schoolScore.button_loading">修改
                            </el-button>
                            <el-button type="primary" @click="handleDeleteMainSchoolScore(item.id)"
                                       style="margin-left: 0px"
                                       :loading="$parentInfo.schoolScore.button_loading">删除
                            </el-button>
                        </td>
                    </tr>
                    <tr :style="{'display':item.hasLook}">
                        <td colspan="12">
                            <table class="table" v-loading="$parentInfo.schoolScore.loading">
                                <thead>
                                <tr>
                                    <th>学科</th>
                                    <th>学科总分</th>
                                    <th>考试成绩</th>
                                    <th>班级平均分/排名</th>
                                    <th>年级平均分/排名</th>
                                    <th>区平均分/排名</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="item1 in item.studentSchoolScores" :key="item1.id">
                                    <td v-if="item1.subject_name">{{item1.subject_name}}</td>
                                    <td v-else>考试科目未填写</td>
                                    <td v-if="item1.examSubject">{{item1.examSubject.totalScore}}</td>
                                    <td v-else>总分未填写</td>
                                    <td>{{item1.score}}</td>
                                    <td v-if="item1.schoolExam_subject_schoolClass">
                                        {{item1.schoolExam_subject_schoolClass.classAvgScore}}&nbsp;/&nbsp;{{item1.classRank}}
                                    </td>
                                    <td v-else> &nbsp;/&nbsp;{{item1.classRank}}</td>
                                    <td v-if="item1.examSubject">{{item1.examSubject.gradeAvgScore}}&nbsp;/&nbsp;{{item1.gradeRank}}</td>
                                    <td v-else>年级平均分未填写</td>
                                    <td v-if="item1.examSubject">{{item1.examSubject.areaAvgScore}}&nbsp;/&nbsp;{{item1.areaRank}}</td>
                                    <td v-else>总平均分未填写</td>
                                </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </template>


                </tbody>
            </table>
        </vue-scroll>
        <!--            </el-tab-pane>-->
        <!--        </el-tabs>-->
    </div>


</template>

<script>
    export default {
        data() {
            return {
                isMounted: false
            };
        },
        created() {
        },
        computed: {
            orderSchoolScores: function () {
                return this._.orderBy(this.$parentInfo.schoolScore.schoolScores, 'id', 'desc');
            },
        },
        mounted() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleGetStudentScore();
            this.isMounted = true;
        },
        methods: {
            handleGetStudentScore() {
                this.$wApi.send(this.$parentInfo.path, 'schoolScore', {
                    'student_id': this.$parentInfo.student_id,
                });
            },
            //studentScore
            handleDeleteMainSchoolScore(studentSchoolExam_id) {
                this.$parentInfo.schoolScore.button_loading = true;
                this.$confirm('确认删除?', '提示', {
                    StartReturn: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$wApi.send(this.$parentInfo.path, 'deleteMainSchoolScore', {
                        'student_id': this.$parentInfo.student_id,
                        'studentSchoolExam_id': studentSchoolExam_id,
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            },
            hasExamDetail(item) {
                if (item.hasLook === 'none') {
                    item.hasLook = '';
                } else {
                    item.hasLook = 'none';
                }
            },
            addScore() {
                this.$Win.openModal('Dialog_AddSchoolScore', 1200, 550, '添加学校考试');
            },
            handleUpdateMainSchoolScore(item) {
                this.$Win.openModal('Dialog_UpdateMainSchoolScore', 1224, 750, '修改学校考试', {
                    'id': item.id,
                    'student_id': this.$parentInfo.student_id,
                });
            },
        }
    }
</script>

<style scoped>

</style>
